import * as React from 'react';
import { cn } from '../cn.ts';

export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-card bg-white shadow-card ring-1 ring-line', className)} {...props} />;
}

export function CardHeader({ title, action, description, as: H = 'h2', className }: { title: React.ReactNode; action?: React.ReactNode; description?: React.ReactNode; as?: 'h2' | 'h3'; className?: string }) {
  return (
    <div className={cn('flex items-start justify-between gap-3 px-5 pt-5 sm:px-6', className)}>
      <div className="min-w-0">
        <H className="text-base font-semibold tracking-tight text-ink">{title}</H>
        {description && <p className="mt-0.5 text-sm text-mid">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export function CardBody({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('px-5 py-5 sm:px-6', className)} {...props} />;
}

/** A definition list row: label on the left, value on the right; stacks on narrow screens. */
export function Row({ label, children, className }: { label: React.ReactNode; children: React.ReactNode; className?: string }) {
  return (
    <div className={cn('flex flex-wrap items-baseline justify-between gap-x-4 gap-y-0.5 py-2.5', className)}>
      <dt className="text-sm text-mid">{label}</dt>
      <dd className="text-right font-medium text-ink">{children}</dd>
    </div>
  );
}
